<template>
  <v-container class="customise-base-view pa-1" fill-height fluid>
    <v-layout fill-height fluid column space-between align-center>
      <BorderedTabs :settings="tabSettings"></BorderedTabs>
      <v-btn
        class="preview-button"
        round=""
        outline=""
        depressed=""
        :href="
          '/preview-manager/feedback/' +
            $store.getters['user/currentCampaign'].id +
            '/' +
            previewType
        "
        target="_blank"
      >
        <img :src="require('@/assets/play.svg')" />
        Preview
      </v-btn>
      <component
        v-if="!loading"
        v-bind:is="view"
        :key="route"
        :view="route"
        :campaign="campaign"
        :questions="questions"
        @save="save"
        @saveQuestion="saveQuestion"
      ></component>

      <v-progress-circular
        v-if="loading"
        :loading="loading"
        indeterminate=""
        class="question-loading"
      ></v-progress-circular>
    </v-layout>
  </v-container>
</template>

<script>
import BorderedTabs from '@/components/BorderedTabs'
import routes from '@/route_names'
import NpsView from './NpsView'
import CsatView from './CsatView'
import CesView from './CesView'
import debounce from 'lodash/debounce'
import campaignApi from '@/api/campaign'
export default {
  name: 'BaseView',
  mixins: [
    {
      computed: {
        routes: function() {
          return routes
        }
      }
    }
  ],
  components: {
    BorderedTabs,
    NpsView,
    CsatView,
    CesView
  },
  props: {
    tabSettings: { type: Object }
  },
  created: function() {},
  data: function() {
    return {
      route: this.$router.currentRoute.name,
      loading: true,
      view: this.getCurrentView(),
      brandTitle: this.$store.getters['user/currentCampaign'].brand_name,
      questions: [],
      campaign: this.$store.getters['user/currentCampaign'],
      previewType: this.getPreviewType()
    }
  },
  computed: {},
  methods: {
    saveCampaign: debounce(function(data) {
      const form = {
        brand_name: data.brandName,
        primary_color: data.brandColor,
        primary_lang: data.language,
        widget_position: data.widgetPosition
      }
      const struct = {
        campaignId: this.$store.getters['user/currentCampaign'].id,
        form: form
      }
      return this.$store
        .dispatch('campaign/updateAppearance', struct)
        .then(function(res) {})
    }, 500),
    save() {},
    saveQuestion: debounce(function(q) {
      campaignApi.updateQuestion(
        this.$router.currentRoute.params.campaignId,
        q.id,
        q
      )
    }, 500),
    getCurrentView: function() {
      if (this.route && this.routeContains(this.route)) return
      const vm = this
      this.loading = true
      if (this.routeContains(routes.SURVEY_CUSTOMIZE_NPS)) {
        this.getQuestions('NPS').then(function(data) {
          vm.questions = data.questions
          vm.loading = false
        })
        this.previewType = 'NPS'
        return NpsView
      } else if (this.routeContains(routes.SURVEY_CUSTOMIZE_CSAT)) {
        this.getQuestions('SAT').then(function(data) {
          vm.questions = data.questions
          vm.loading = false
        })
        this.previewType = 'SAT'
        return CsatView
      } else if (this.routeContains(routes.SURVEY_CUSTOMIZE_CES)) {
        this.getQuestions('ES').then(function(data) {
          vm.questions = data.questions
          vm.loading = false
        })
        this.previewType = 'ES'
        return CesView
      }
    },
    getQuestions: function(metric) {
      return this.$store.dispatch('campaign/getQuestions', {
        campaignId: this.$router.currentRoute.params.campaignId,
        type: metric
      })
    },
    getPreviewType() {
      if (this.routeContains(routes.SURVEY_CUSTOMIZE_NPS)) {
        return 'NPS'
      }
      if (this.routeContains(routes.SURVEY_CUSTOMIZE_CSAT)) {
        return 'SAT'
      }
      if (this.routeContains(routes.SURVEY_CUSTOMIZE_CES)) {
        return 'ES'
      }
    }
  },
  watch: {
    $route: function(to, from) {
      this.view = this.getCurrentView()
      this.route = to.name
    }
  },
  beforeRouteUpdate(to, from, next) {
    next()
  }
}
</script>

<style lang="stylus">
.customise-base-view {
    position relative
    .preview-button {
        background: #F5F9FD;
        border-color : $color-primary-light-5
        color: $color-primary-light-1
        width 120px
        font-weight normal
        font-size 14px
        position: fixed;
        top: 3px;
        z-index: 2;
        right: 3px;
        height 30px
        img {
          height 12px
        }
    }
    .lgrm-box-input {
        min-width 60px

        &.brand-title-input[disabled], &.brand-title-input[disabled] {
            color: $color-primary;
            border-bottom: 1px solid $color-primary;
            cursor not-allowed
        }
    }

    .question-loading {
        margin-top 20%
        margin-bottom 20%
    }

    .design-label {
      color $color-primary-light-5
      font-size: 13px
      padding-right 10px
      
    }

    .driver-question, .openended-question {
      position relative
      .design-label {
        position: absolute;
        left: -75px;
        top: 15px;
      }
    }

    .lg-select {
      .v-input__slot {
        border: 1px solid $color-primary-light-5 !important;
        }
      
      .v-select__selection {
        font-size: 14px
        font-weight: normal
        color: $color-primary-light-1
      }
    }
    
}
.lgrm-emoji-label {
      padding 4px 10px !important
    }
    .lgrm-emoji .lgrm-emoji-tooltip
    {
      .lgrm-emoji-tooltip-content {
        padding 3px 10px !important
      }
      
      .lgrm-arrow {
        top: -3px !important
      }
    }

    
</style>
